/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import navigation from 'services/NavigationService';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
  location?: Object,
  user?: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class StartAuditSuccess extends React.Component<*> {
  continue() {
    const { type, location, user } = this.props;

    if (type === 'locations') {
      const linkToLocationAssets: Object = {
        pathname: `/assets/location/${location.id}`,
        state: { location, locationName: location.name },
      };
      const linkToCountryAssets: Object = {
        pathname: `/assets/company/${location.company_id}/country/${location.id}`,
        state: { location, locationName: location.name },
      };

      navigation.navigateTo(location.country_id ? linkToLocationAssets : linkToCountryAssets);
    }

    if (type === 'users') {
      const userLinkUserAssets: Object = {
        pathname: `/assets/user/${user.id}`,
        state: { user, userName: user.name },
      };

      navigation.navigateTo(userLinkUserAssets);
    }
  }

  render(): React.Node {
    const { t }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <div className={styles['action-drawer-block-row']}>
              {t('actionDrawer:Begin your asset audit by selecting ')}
              <span>
                <img height="14px" width="14px" src={'/icons/checkbox-checked.png'} />
              </span>
              {t('actionDrawer:the assets that are present in the location to be audited.')}
            </div>
            <div className={styles['action-drawer-block-row']}>
              {t('actionDrawer:Once all relevant assets have been selected, use the')}
            </div>
            <div className={styles['action-drawer-block-row']}>
              <img width="110px" src={'/icons/submit-audit-btn.png'} />
            </div>
            <div className={styles['action-drawer-block-row']}>
              {t(
                'actionDrawer:button at the top of the table to submit your results and confirm that the assets have been audited.'
              )}
            </div>
            <div className={styles['action-drawer-block-row']}>
              {t('actionDrawer:Audited assets will be marked with')}
              <span>
                <img height="14px" width="14px" src={'/icons/success-tick.png'} />
              </span>
            </div>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button color="primary" variant="contained" onClick={() => this.continue()}>
            {t('general:Continue')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
